import { SaveButton, CancelButton } from "../../../common/Buttons";

export const CustomEditActionButtons = ({
  table,
  row,
  handleUpdateOrder,
  newRow,
}) => {
  const handleCancel = () => {
    table.setEditingRow(null);
  };

  const handleSave = async () => {
    const values = { ...newRow };
    await handleUpdateOrder({ values, table });
  };

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      <SaveButton onClick={handleSave} />
      <CancelButton onClick={handleCancel} />
    </div>
  );
};

export default CustomEditActionButtons;
